import network from '../../utils/network';

interface getEventsParams {
  limit?: number;
  ticketProviderId?: string;
  location?: any;
}

interface createEvent {
  name: string;
  description: string;
  imageUrl?: string;
  ticketProviderId: string | number;
  longDescriptions: string;
  uuid: string;
}

export const getEvents = async ({ limit, ticketProviderId, location }: getEventsParams) => {
  let params: { [key: string]: any } = {};
  params.limit = limit;
  ticketProviderId && (params.ticketProviderId = ticketProviderId);

  const response = await network.get({
    path: `/events`,
    options: {
      params,
    },
  });
  return response?.data;
};

export const getTicketProviders = async ({ location }: any) => {
  const { pathname } = location;
  let path = 'validate-web-backend';
  if (pathname.split('/').includes('validate-backend')) {
    path = 'validate-admin-backend';
  }

  try {
    const response = await network.get({
      path: `/ticket-providers/get-all`,
    });
    return response?.data;
  } catch (err: any) {
    return err;
  }
};

export const createEventService = async (data: createEvent, location: any) => {
  const { pathname } = location;
  let path = 'validate-web-backend';
  if (pathname.split('/').includes('validate-backend')) {
    path = 'validate-admin-backend';
  }

  const response = await network.post(`/events`, data);

  return response?.data;
};

export const updateEventService = async (data: createEvent) => {
  const response = await network.patch(`/events/${data.uuid}`, data);

  return response?.data;
};

export const getTimeZones = async () => {
  const response = await network.get({
    path: '/events/timezones',
  });

  return response?.data;
};
